// src/components/admin/page-management/section-forms/ContainerForm.js
import React, { useState } from 'react';

const ContainerForm = ({ content, updateContent }) => {
  const [activeTab, setActiveTab] = useState('general'); // 'general', 'layout', 'advanced'

  return (
    <div>
      <h3 className="font-bold text-lg mb-4">Container Section</h3>

      {/* Enhanced Tabs Navigation */}
      <div className="flex flex-wrap justify-start gap-2 border-b border-gray-200 mb-6 px-1">
        {[
          { key: 'general', label: 'General' },
          { key: 'layout', label: 'Layout' },
          { key: 'advanced', label: 'Advanced' }
        ].map(({ key, label }) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            className={`relative px-5 py-2.5 text-sm font-medium rounded-t-lg transition-all duration-200 ease-in-out
        ${activeTab === key
                ? 'bg-white border border-b-0 border-indigo-500 text-indigo-600 shadow-sm'
                : 'text-gray-600 hover:text-indigo-500 hover:bg-gray-100'}`}
          >
            {label}
            {activeTab === key && (
              <span className="absolute bottom-0 left-0 w-full h-[2px] bg-indigo-500 rounded-t-lg" />
            )}
          </button>
        ))}
      </div>

      {/* Enhanced General Tab */}
      {activeTab === 'general' && (
  <div className="space-y-6">

    {/* Container Type */}
    <div className="p-5">
      <label className="block text-sm font-bold text-blue-700 mb-2">Container Type</label>
      <select
        className="w-full p-3 border-2 border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        value={content?.containerType || 'standard'}
        onChange={(e) => updateContent('containerType', e.target.value)}
      >
        <option value="standard">Standard</option>
        <option value="flex">Flexbox</option>
        <option value="grid">Grid</option>
      </select>
      <p className="text-xs text-blue-600 mt-1">
        Select how child elements will be arranged within the container.
      </p>
    </div>

    {/* Background + Width */}
    <div className="grid md:grid-cols-2 gap-6">
      <div className="p-5">
        <label className="block text-sm font-bold text-pink-700 mb-2">Background Color</label>
        <input
          type="text"
          className="w-full p-3 border-2 border-pink-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-pink-400"
          value={content?.backgroundColor || ''}
          onChange={(e) => updateContent('backgroundColor', e.target.value)}
          placeholder="#ffffff or rgba(255,255,255,0.8)"
        />
      </div>

      <div className="p-5">
        <label className="block text-sm font-bold text-indigo-700 mb-2">Width</label>
        <input
          type="text"
          className="w-full p-3 border-2 border-indigo-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
          value={content?.width || '100%'}
          onChange={(e) => updateContent('width', e.target.value)}
          placeholder="100%, 300px, auto"
        />
      </div>
    </div>

    {/* Max Width + Height */}
    <div className="grid md:grid-cols-2 gap-6">
      <div className="p-5">
        <label className="block text-sm font-bold text-yellow-700 mb-2">Max Width</label>
        <input
          type="text"
          className="w-full p-3 border-2 border-yellow-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
          value={content?.maxWidth || ''}
          onChange={(e) => updateContent('maxWidth', e.target.value)}
          placeholder="1200px, none"
        />
      </div>

      <div className="p-5">
        <label className="block text-sm font-bold text-green-700 mb-2">Height</label>
        <input
          type="text"
          className="w-full p-3 border-2 border-green-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
          value={content?.height || ''}
          onChange={(e) => updateContent('height', e.target.value)}
          placeholder="auto, 500px, 50vh"
        />
      </div>
    </div>

    {/* Min Height + Padding */}
    <div className="grid md:grid-cols-2 gap-6">
      <div className="p-5">
        <label className="block text-sm font-bold text-cyan-700 mb-2">Min Height</label>
        <input
          type="text"
          className="w-full p-3 border-2 border-cyan-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-400"
          value={content?.minHeight || ''}
          onChange={(e) => updateContent('minHeight', e.target.value)}
          placeholder="300px, 50vh"
        />
      </div>

      <div className="p-5">
        <label className="block text-sm font-bold text-rose-700 mb-2">Padding</label>
        <input
          type="text"
          className="w-full p-3 border-2 border-rose-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-rose-400"
          value={content?.padding || '1rem'}
          onChange={(e) => updateContent('padding', e.target.value)}
          placeholder="1rem, 20px, 1rem 2rem"
        />
      </div>
    </div>

    {/* Margin */}
    <div className="p-5">
      <label className="block text-sm font-bold text-gray-700 mb-2">Margin</label>
      <input
        type="text"
        className="w-full p-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
        value={content?.margin || ''}
        onChange={(e) => updateContent('margin', e.target.value)}
        placeholder="auto, 1rem, 10px 20px"
      />
    </div>
  </div>
)}

      {/* Enhanced Layout Tab */}
      {activeTab === 'layout' && (
        <div className="space-y-6">
          {/* FLEX Options */}
          {content?.containerType === 'flex' && (
            <>
              <div className="p-5">
                <label className="block text-sm font-semibold text-indigo-700 mb-2">Flex Direction</label>
                <select
                  className="w-full p-3 border-2 border-indigo-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
                  value={content?.flexDirection || 'row'}
                  onChange={(e) => updateContent('flexDirection', e.target.value)}
                >
                  <option value="row">Row</option>
                  <option value="row-reverse">Row Reverse</option>
                  <option value="column">Column</option>
                  <option value="column-reverse">Column Reverse</option>
                </select>
              </div>

              <div className="p-5">
                <label className="block text-sm font-semibold text-purple-700 mb-2">Flex Wrap</label>
                <select
                  className="w-full p-3 border-2 border-purple-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white"
                  value={content?.flexWrap || 'wrap'}
                  onChange={(e) => updateContent('flexWrap', e.target.value)}
                >
                  <option value="nowrap">No Wrap</option>
                  <option value="wrap">Wrap</option>
                  <option value="wrap-reverse">Wrap Reverse</option>
                </select>
              </div>

              <div className="p-5">
                <label className="block text-sm font-semibold text-green-700 mb-2">Justify Content</label>
                <select
                  className="w-full p-3 border-2 border-green-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 bg-white"
                  value={content?.justifyContent || 'flex-start'}
                  onChange={(e) => updateContent('justifyContent', e.target.value)}
                >
                  <option value="flex-start">Start</option>
                  <option value="center">Center</option>
                  <option value="flex-end">End</option>
                  <option value="space-between">Space Between</option>
                  <option value="space-around">Space Around</option>
                  <option value="space-evenly">Space Evenly</option>
                </select>
              </div>

              <div className=" p-5">
                <label className="block text-sm font-semibold text-yellow-700 mb-2">Align Items</label>
                <select
                  className="w-full p-3 border-2 border-yellow-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 bg-white"
                  value={content?.alignItems || 'stretch'}
                  onChange={(e) => updateContent('alignItems', e.target.value)}
                >
                  <option value="stretch">Stretch</option>
                  <option value="flex-start">Start</option>
                  <option value="center">Center</option>
                  <option value="flex-end">End</option>
                  <option value="baseline">Baseline</option>
                </select>
              </div>
            </>
          )}

          {/* GRID Options */}
          {content?.containerType === 'grid' && (
            <>
              <div className=" p-5">
                <label className="block text-sm font-semibold text-cyan-700 mb-2">Grid Columns</label>
                <input
                  type="text"
                  className="w-full p-3 border-2 border-cyan-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 bg-white"
                  value={content?.gridColumns || '1fr 1fr 1fr'}
                  onChange={(e) => updateContent('gridColumns', e.target.value)}
                  placeholder="1fr 1fr 1fr, repeat(3, 1fr), 200px auto 200px"
                />
                <p className="text-xs text-gray-500 mt-1">Define columns using CSS grid syntax</p>
              </div>

              <div className="p-5">
                <label className="block text-sm font-semibold text-pink-700 mb-2">Grid Rows</label>
                <input
                  type="text"
                  className="w-full p-3 border-2 border-pink-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-pink-500 bg-white"
                  value={content?.gridRows || 'auto'}
                  onChange={(e) => updateContent('gridRows', e.target.value)}
                  placeholder="auto, 100px 200px auto, repeat(3, auto)"
                />
              </div>

              <div className=" p-5">
                <label className="block text-sm font-semibold text-lime-700 mb-2">Grid Gap</label>
                <input
                  type="text"
                  className="w-full p-3 border-2 border-lime-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-lime-500 bg-white"
                  value={content?.gridGap || '1rem'}
                  onChange={(e) => updateContent('gridGap', e.target.value)}
                  placeholder="1rem, 10px, 1rem 2rem"
                />
              </div>

              <div className="p-5">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Grid Template Areas</label>
                <textarea
                  className="w-full p-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500 bg-white min-h-[100px]"
                  value={content?.gridTemplateAreas || ''}
                  onChange={(e) => updateContent('gridTemplateAreas', e.target.value)}
                  placeholder={`"header header header"\n"sidebar content content"\n"footer footer footer"`}
                />
                <p className="text-xs text-gray-500 mt-1">Define named grid areas (each row in quotes)</p>
              </div>
            </>
          )}
        </div>
      )}

      {/* Enhanced Advanced Tab */}
      {activeTab === 'advanced' && (
        <div className="space-y-6">

          {/* Border Settings */}
          <div className=" p-5">
            <label className="block text-sm font-bold text-blue-700 mb-2">Border</label>
            <div className="grid grid-cols-3 gap-3">
              <input
                type="text"
                className="p-3 border-2 border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-400"
                value={content?.borderWidth || ''}
                onChange={(e) => updateContent('borderWidth', e.target.value)}
                placeholder="Width (1px)"
              />
              <select
                className="p-3 border-2 border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-400"
                value={content?.borderStyle || 'none'}
                onChange={(e) => updateContent('borderStyle', e.target.value)}
              >
                <option value="none">None</option>
                <option value="solid">Solid</option>
                <option value="dashed">Dashed</option>
                <option value="dotted">Dotted</option>
                <option value="double">Double</option>
              </select>
              <input
                type="text"
                className="p-3 border-2 border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-400"
                value={content?.borderColor || ''}
                onChange={(e) => updateContent('borderColor', e.target.value)}
                placeholder="Color (#ccc)"
              />
            </div>
          </div>

          {/* Border Radius */}
          <div className="p-5">
            <label className="block text-sm font-bold text-pink-700 mb-2">Border Radius</label>
            <input
              type="text"
              className="w-full p-3 border-2 border-pink-200 rounded-lg focus:ring-2 focus:ring-pink-400"
              value={content?.borderRadius || ''}
              onChange={(e) => updateContent('borderRadius', e.target.value)}
              placeholder="0, 5px, 50%"
            />
          </div>

          {/* Box Shadow */}
          <div className=" p-5">
            <label className="block text-sm font-bold text-yellow-700 mb-2">Box Shadow</label>
            <input
              type="text"
              className="w-full p-3 border-2 border-yellow-200 rounded-lg focus:ring-2 focus:ring-yellow-400"
              value={content?.shadow || ''}
              onChange={(e) => updateContent('shadow', e.target.value)}
              placeholder="0 2px 5px rgba(0,0,0,0.1)"
            />
          </div>

          {/* Position */}
          <div className="p-5">
            <label className="block text-sm font-bold text-green-700 mb-2">Position</label>
            <select
              className="w-full p-3 border-2 border-emerald-200 rounded-lg focus:ring-2 focus:ring-emerald-400"
              value={content?.position || 'static'}
              onChange={(e) => updateContent('position', e.target.value)}
            >
              <option value="static">Static (Default)</option>
              <option value="relative">Relative</option>
              <option value="absolute">Absolute</option>
              <option value="fixed">Fixed</option>
              <option value="sticky">Sticky</option>
            </select>
          </div>

          {/* Position Offsets */}
          {content?.position && content.position !== 'static' && (
            <div className="p-5">
              <label className="block text-sm font-bold text-indigo-700 mb-2">Offsets</label>
              <div className="grid grid-cols-2 gap-4">
                {['top', 'right', 'bottom', 'left'].map((pos) => (
                  <div key={pos}>
                    <label className="block text-xs font-medium mb-1 capitalize text-gray-700">{pos}</label>
                    <input
                      type="text"
                      className="w-full p-3 border-2 border-indigo-200 rounded-lg focus:ring-2 focus:ring-indigo-400"
                      value={content?.[pos] || ''}
                      onChange={(e) => updateContent(pos, e.target.value)}
                      placeholder="20px, 2rem, auto"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Z-Index */}
          <div className="p-5">
            <label className="block text-sm font-bold text-gray-700 mb-2">Z-Index</label>
            <input
              type="number"
              className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500"
              value={content?.zIndex || '0'}
              onChange={(e) => updateContent('zIndex', e.target.value)}
              placeholder="0"
            />
          </div>
        </div>
      )}


      {/* Preview Section */}
      <div className="mt-6 border-t pt-4">
        <h4 className="font-medium mb-2">Container Preview</h4>
        <div
          className="p-4 bg-gray-100 border rounded"
          style={{
            minHeight: '150px',
            display: content?.containerType === 'flex' ? 'flex' :
              content?.containerType === 'grid' ? 'grid' : 'block',
            flexDirection: content?.flexDirection || 'row',
            flexWrap: content?.flexWrap || 'wrap',
            justifyContent: content?.justifyContent || 'flex-start',
            alignItems: content?.alignItems || 'stretch',
            gridTemplateColumns: content?.gridColumns || '1fr 1fr 1fr',
            gridTemplateRows: content?.gridRows || 'auto',
            gap: content?.gridGap || '1rem',
            backgroundColor: content?.backgroundColor || 'transparent',
            padding: content?.padding || '1rem',
            margin: content?.margin || '0',
            width: content?.width || '100%',
            height: content?.height || 'auto',
            minHeight: content?.minHeight || '150px',
            borderRadius: content?.borderRadius || '0',
            borderWidth: content?.borderWidth || '0',
            borderStyle: content?.borderStyle || 'none',
            borderColor: content?.borderColor || 'transparent',
            boxShadow: content?.shadow || 'none',
            position: content?.position || 'static',
            top: content?.top || 'auto',
            right: content?.right || 'auto',
            bottom: content?.bottom || 'auto',
            left: content?.left || 'auto',
            zIndex: content?.zIndex || 'auto'
          }}
        >
          {/* Placeholder boxes to visualize the container */}
          {(content?.containerType === 'flex' || content?.containerType === 'grid') && (
            <>
              <div style={{ backgroundColor: '#e0e7ff', padding: '1rem', borderRadius: '4px', textAlign: 'center' }}>
                Item 1
              </div>
              <div style={{ backgroundColor: '#e0e7ff', padding: '1rem', borderRadius: '4px', textAlign: 'center' }}>
                Item 2
              </div>
              <div style={{ backgroundColor: '#e0e7ff', padding: '1rem', borderRadius: '4px', textAlign: 'center' }}>
                Item 3
              </div>
            </>
          )}

          {content?.containerType === 'standard' && (
            <div style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>
              Standard Container<br />
              <span className="text-xs">Child elements will flow normally</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContainerForm;